// 使用 actioncable-vue 的配置文件
// 这个文件主要用于配置 actioncable-vue 插件

// ActionCable 配置选项
export const cableConfig = {
  debug: import.meta.env.MODE === 'development',
  debugLevel: 'error',
  connectionUrl: import.meta.env.VITE_CABLE_URL || 'ws://localhost:3000/cable',
  connectImmediately: false // 手动控制连接时机
}

// 频道配置
export const channelConfig = {
  // 聊天频道配置
  chatChannel: 'ChatChannel',
  userStatusChannel: 'UserStatusChannel',

  // 聊天频道参数
  getChatParams: (userId, recipientId = null) => ({
    channel: 'ChatChannel',
    user_id: userId,
    recipient_id: recipientId
  }),

  // 用户状态频道参数
  getUserStatusParams: (userId) => ({
    channel: 'UserStatusChannel',
    user_id: userId
  }),

  // 频道方法
  actions: {
    SEND_MESSAGE: 'send_message',
    TYPING: 'typing',
    HEARTBEAT: 'heartbeat'
  }
}

// 消息类型常量
export const MESSAGE_TYPES = {
  MESSAGE: 'message',
  TYPING: 'typing',
  USER_ONLINE: 'user_online',
  USER_OFFLINE: 'user_offline'
}

// 工具函数
export const cableUtils = {
  // 生成频道名称
  generateChannelName: (channelType, params) => {
    switch (channelType) {
      case 'chat':
        return params.recipientId ? `chat_${params.recipientId}` : `chat_${params.userId}`
      case 'user_status':
        return 'user_status'
      default:
        return channelType
    }
  },

  // 格式化消息数据
  formatMessage: (data) => ({
    id: data.message?.id || Date.now(),
    content: data.message?.content || data.content,
    user: data.message?.user || data.user,
    timestamp: data.message?.timestamp || data.timestamp || new Date(),
    type: data.message?.type || data.type || 'text',
    isSelf: data.message?.is_self || data.is_self || false,
    recipientId: data.message?.recipient_id || data.recipient_id
  }),

  // 格式化用户状态数据
  formatUserStatus: (data) => ({
    user: data.user,
    type: data.type, // 'user_online' 或 'user_offline'
    timestamp: data.timestamp || new Date()
  }),

  // 格式化输入状态数据
  formatTypingStatus: (data) => ({
    user: data.user,
    isTyping: data.is_typing,
    timestamp: data.timestamp || new Date()
  })
}
